document.addEventListener("DOMContentLoaded", function () {
  const locationElement = document.getElementById("user-location");
  const shippingRatesElement = document.getElementById("shipping-rates");
  const changeLocationBtn = document.getElementById("change-location");
  const countrySelector = document.getElementById("country-selector");

  // Lists (UAE kept for shipping logic; it's not part of the combined dropdown)
  const uae = ["United Arab Emirates"];
  const expeditedFreeShipping = [
    "Austria","Australia","Belgium","Canada","Switzerland","Czechia","Germany","Denmark","Spain","Finland","France",
    "United Kingdom","Hong Kong SAR","Ireland","Italy","Japan","Malaysia","Netherlands","Norway","New Zealand","Poland",
    "Portugal","Sweden","Singapore","United States","Åland Islands","Argentina","Ascension Island","Bahrain","Bangladesh",
    "Bhutan","Brazil","British Indian Ocean Territory","Bulgaria","Cambodia","Caribbean Netherlands","China",
    "Christmas Island","Cocos (Keeling) Islands","Croatia","Cyprus","Egypt","French Polynesia",
    "French Southern Territories","Greece","Hungary","Iceland","India","Indonesia","Isle of Man","Jordan","Kuwait",
    "Latvia","Lebanon","Liechtenstein","Lithuania","Luxembourg","Macao SAR","Mexico","Monaco","Nepal","Norfolk Island",
    "Oman","Pakistan","Palestinian Territories","Philippines","Pitcairn Islands","Qatar","Réunion","Romania",
    "São Tomé & Príncipe","Saudi Arabia","Sint Maarten","Slovakia","Slovenia","South Georgia & South Sandwich Islands",
    "Sri Lanka","St. Helena","St. Pierre & Miquelon","Svalbard & Jan Mayen","Taiwan","Thailand","Tokelau",
    "Tristan da Cunha","Türkiye","U.S. Outlying Islands","Vatican City","Vietnam","Wallis & Futuna","Western Sahara"
  ];
  const dhlExpress = [
    "Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua & Barbuda","Armenia","Aruba","Azerbaijan",
    "Bahamas","Barbados","Belarus","Belize","Benin","Bermuda","Bolivia","Bosnia & Herzegovina","Botswana",
    "British Virgin Islands","Brunei","Burkina Faso","Burundi","Cameroon","Cape Verde","Cayman Islands",
    "Central African Republic","Chad","Chile","Colombia","Comoros","Côte d’Ivoire","Congo - Brazzaville","Congo - Kinshasa","Cook Islands",
    "Costa Rica","Curaçao","Djibouti","Dominica","Dominican Republic","Ecuador","El Salvador","Equatorial Guinea",
    "Eritrea","Estonia","Eswatini","Ethiopia","Falkland Islands","Faroe Islands","Fiji","French Guiana","Gabon","Gambia",
    "Georgia","Ghana","Gibraltar","Greenland","Grenada","Guadeloupe","Guatemala","Guernsey","Guinea","Guinea-Bissau",
    "Guyana","Haiti","Honduras","Iraq","Jamaica","Jersey","Kazakhstan","Kenya","Kiribati","Kosovo","Kyrgyzstan","Laos",
    "Lesotho","Liberia","Libya","Madagascar","Malawi","Maldives","Mali","Malta","Martinique","Mauritania","Mauritius",
    "Mayotte","Moldova","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar (Burma)","Namibia","Nauru",
    "New Caledonia","Nicaragua","Niger","Nigeria","Niue","North Macedonia","Panama","Papua New Guinea","Paraguay","Peru",
    "Russia","Rwanda","Samoa","San Marino","Senegal","Serbia","Seychelles","Sierra Leone","Solomon Islands","Somalia",
    "South Africa","South Sudan","St. Barthélemy","St. Kitts & Nevis","St. Lucia","St. Martin","St. Vincent & Grenadines",
    "Sudan","Suriname","Tajikistan","Tanzania","Timor-Leste","Togo","Tonga","Trinidad & Tobago","Tunisia","Turkmenistan",
    "Turks & Caicos Islands","Tuvalu","Uganda","Ukraine","Uruguay","Uzbekistan","Vanuatu","Venezuela","Yemen","Zambia",
    "Zimbabwe","South Korea"
  ];

  // Price numeric only; format on display
  const productPrice = parseFloat(
    (document.getElementById("product-price").getAttribute("data-price") || "0").toString().replace(/[^0-9.]/g, "")
  ) || 0;

  let userCountry = null;
  let countriesLoaded = false;

  async function fetchUserLocation() {
    const showPicker = () => {
      countrySelector.style.display = "block";
      locationElement.style.display = "none";
      countrySelector.focus();
      if (typeof countrySelector.showPicker === "function") { try { countrySelector.showPicker(); } catch(_){} }
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (pos) => {
        try {
          const { latitude: lat, longitude: lon } = pos.coords;
          const resp = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`);
          const data = await resp.json();
          userCountry = data?.address?.country || null;
          if (userCountry) {
            locationElement.value = userCountry;
            calculateShipping(userCountry);
          } else {
            locationElement.value = "Choose your country";
            showPicker();
            await ensureCountriesLoaded();
          }
        } catch {
          locationElement.value = "Choose your country";
          showPicker();
          await ensureCountriesLoaded();
        }
      }, async () => {
        locationElement.value = "Choose your country";
        showPicker();
        await ensureCountriesLoaded();
      });
    } else {
      locationElement.value = "Choose your country";
      showPicker();
      await ensureCountriesLoaded();
    }
  }

  function calculateShipping(country) {
    let shippingCost = 0;

    if (uae.includes(country)) {
      shippingCost = productPrice >= 50 ? 0 : 10;
    } else if (expeditedFreeShipping.includes(country)) {
      shippingCost = productPrice >= 51 ? 0 : 25;
    } else if (dhlExpress.includes(country)) {
      shippingCost = productPrice >= 51 ? 39 : 69;
    } else {
      shippingCost = productPrice >= 51 ? 0 : 25;
    }

    const totalPrice = productPrice + shippingCost;
    displayShippingCost(productPrice, shippingCost, totalPrice);
  }

  function displayShippingCost(productPrice, shippingCost, totalPrice) {
    shippingRatesElement.innerHTML = `
      <p><strong>Product Price:</strong> USD ${productPrice.toFixed(2)}</p>
      <p><strong>Shipping Cost:</strong> USD ${shippingCost.toFixed(2)}</p>
      <p><strong>Total Price (incl. shipping):</strong> USD ${totalPrice.toFixed(2)}</p>
    `;
  }

  function openCountryPicker() {
    countrySelector.style.display = "block";
    locationElement.style.display = "none";
    ensureCountriesLoaded().then(() => {
      if (userCountry) {
        const opt = Array.from(countrySelector.options).find(o => o.value === userCountry);
        if (opt) opt.selected = true;
      }
      countrySelector.focus();
      if (typeof countrySelector.showPicker === "function") { try { countrySelector.showPicker(); } catch(_){} }
    });
  }

  // Build a single combined list (no groups)
  async function ensureCountriesLoaded() {
    if (countriesLoaded) return;

    // Reset but keep the placeholder
    const placeholder = countrySelector.querySelector("option");
    countrySelector.innerHTML = "";
    if (placeholder) countrySelector.appendChild(placeholder);

    const collator = new Intl.Collator(undefined, { sensitivity: "base" });

    const mergedSorted = Array.from(new Set([
      ...expeditedFreeShipping,
      ...dhlExpress
    ])).sort(collator.compare);

    mergedSorted.forEach(name => {
      const o = document.createElement("option");
      o.value = name;
      o.textContent = name;
      countrySelector.appendChild(o);
    });

    countriesLoaded = true;
  }

  // Events
  changeLocationBtn.addEventListener("click", function (e) {
    e.preventDefault();
    openCountryPicker();
  });
  locationElement.addEventListener("click", openCountryPicker);

  countrySelector.addEventListener("change", function () {
    const selectedCountry = countrySelector.value;
    if (selectedCountry) {
      locationElement.value = selectedCountry;
      locationElement.style.display = "block";
      countrySelector.style.display = "none";
      calculateShipping(selectedCountry);
    }
  });

  // Init
  fetchUserLocation();
});